/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const RETRIEVE_SCANNER_STACK_FAILED_MSG =
  'failed to retrieve scanner stack'
export const RETRIEVE_STORAGE_STACK_FAILED_MSG =
  'failed to retrieve storage stack'
export const STACK_ALREADY_DEPLOYED_MSG = 'the stack has been deployed already'
export const UPDATE_AZURE_LICENSE_FAILED_MSG =
  'failed to update license to Azure stack'
export const SCANNER_IS_UPDATING_BY_OTHERS =
  'scanner stack is updating by others'
